import React, { FC, FunctionComponent, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Loader from 'src/components/widgets/loader';
import NotFoundPage from '../components/pages/_notFound';
import Toolbar from '../components/widgets/toolbar/toolbar';
import { Center } from '../shared/globals';
import { backofficeAnonymousUrl, routeMatchUrl } from '../shared/helpers';
import routes from '../shared/routes';
import { GuestLayoutContainer } from './guestLayoutContainer';

interface GuestLayoutProps {
    isPricing: boolean;
    children?: React.ReactNode;
}

const GuestLayout: FunctionComponent<GuestLayoutProps> = ({ isPricing }) => {
    return (
        <Suspense
            fallback={
                <Center>
                    <Loader />
                </Center>
            }
        >
            <GuestLayoutContainer>
                {isPricing && <Toolbar isMenuHidden={true} forceTools={true} showBackButton={isPricing} isGuest />}
                <Routes>
                    {routes
                        .filter((x) => x.isGuestAllowed)
                        .map((route, index) => {
                            const anonymousPath = routeMatchUrl(backofficeAnonymousUrl(route.url));
                            const defaultPath = routeMatchUrl(route.url);

                            return (
                                <React.Fragment key={index}>
                                    <Route path={anonymousPath} element={React.createElement(route.component as FC<{}>)} />
                                    <Route path={defaultPath} element={React.createElement(route.component as FC<{}>)} />
                                </React.Fragment>
                            );
                        })}
                    <Route path='*' element={<NotFoundPage />} />
                </Routes>
            </GuestLayoutContainer>
        </Suspense>
    );
};

export default GuestLayout;
